import theme from '../base'

const breadcrumbs = {
  MuiBreadcrumbs: {
    styleOverrides: {
      root: {
        color: theme.palette.neutral.light,

        '& .MuiBreadcrumbs-separator': {
          color: theme.palette.neutral.lighter,
        },
      },
    },
  },
}

export default breadcrumbs
